import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedNumber } from 'react-intl';
import { TypeFilter } from '../../interfaces/interfaces';

interface Props {
  typeFilter: TypeFilter;
  toggleFilterByReturn: (checked: boolean) => void;
  setReturnFilterValue: (value: number) => void;
  setTypeFilter: (typeFilter: TypeFilter) => void;
  shouldFilterByReturn: boolean;
  returnFilterValue: number;
  extremes: {
    max: number;
    min: number;
  };
}

export default class PortfolioFilter extends Component<Props> {
  /*
    This component is showing filter options, and provides the possibility
    to apply filters on equities.
  */

  classNameIfCurrent = (typeFilter: TypeFilter) =>
    this.props.typeFilter === typeFilter ? 'active' : '';

  toggleFilterByReturn = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.toggleFilterByReturn(event.target.checked);
  };

  rangeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.setReturnFilterValue(parseInt(event.target.value));
  };

  render() {
    let filterByReturn;
    let filterWrapper;
    const { extremes } = this.props;

    if (this.props.shouldFilterByReturn) {
      filterByReturn = (
        <div>
          <FormattedNumber
            minimumFractionDigits={0}
            maximumFractionDigits={0}
            value={this.props.returnFilterValue}
          />
          <input
            min={extremes.min}
            max={extremes.max}
            onChange={this.rangeChanged}
            type="range"
          />
        </div>
      );
    }

    if (this.props.typeFilter !== 'SUMMARY') {
      filterWrapper = (
        <div className="range-filter">
          <input
            onChange={this.toggleFilterByReturn}
            checked={this.props.shouldFilterByReturn}
            type="checkbox"
            id="enable-range"
          />
          <label htmlFor="enable-range">Filtrer på minimum avkastning: </label>
          {filterByReturn}
        </div>
      );
    }

    return (
      <div>
        <div className="filter-wrapper">
          <Button
            variant="light"
            size="sm"
            className={this.classNameIfCurrent('NONE')}
            onClick={() => this.props.setTypeFilter('NONE')}
          >
            Vis alle
          </Button>
          <Button
            variant="light"
            size="sm"
            className={this.classNameIfCurrent('Fund')}
            onClick={() => this.props.setTypeFilter('Fund')}
          >
            Fond
          </Button>
          <Button
            variant="light"
            size="sm"
            className={this.classNameIfCurrent('Crypto')}
            onClick={() => this.props.setTypeFilter('Crypto')}
          >
            Crypto
          </Button>
          <Button
            variant="light"
            size="sm"
            className={this.classNameIfCurrent('Share')}
            onClick={() => this.props.setTypeFilter('Share')}
          >
            Aksjer
          </Button>
          <Button
            variant="light"
            size="sm"
            className={this.classNameIfCurrent('ETF')}
            onClick={() => this.props.setTypeFilter('ETF')}
          >
            ETF
          </Button>
          <Button
            variant="light"
            size="sm"
            className={this.classNameIfCurrent('SUMMARY')}
            onClick={() => this.props.setTypeFilter('SUMMARY')}
          >
            Sammendrag
          </Button>
        </div>
        {filterWrapper}
      </div>
    );
  }
}
